import React from "react";

function ReportsExportsIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 23.168 20.594">
      <path
        d="M22.866,7.137l-5.792,5.47a.966.966,0,0,1-1.628-.7V9.011C9.63,9.05,7.177,10.423,8.818,15.9a.644.644,0,0,1-1.006.7,7.742,7.742,0,0,1-2.985-5.766c0-5.789,4.73-6.938,10.619-6.971V.966a.966.966,0,0,1,1.628-.7l5.792,5.47A.966.966,0,0,1,22.866,7.137Zm-7.42,8.112v2.77H2.574V5.148H4.622A.482.482,0,0,0,4.97,5,7.841,7.841,0,0,1,7.022,3.484a.482.482,0,0,0-.223-.91H1.931A1.931,1.931,0,0,0,0,4.5V18.663a1.931,1.931,0,0,0,1.931,1.931H16.089a1.931,1.931,0,0,0,1.931-1.931V15.091a.483.483,0,0,0-.644-.455A2.889,2.889,0,0,1,16,14.772.484.484,0,0,0,15.445,15.249Z"
        transform="translate(0 0)"
      />
    </svg>
  );
}

export { ReportsExportsIcon };
